import React, { useState } from 'react';

const Logo = ({ size = 'medium' }) => {
  const [imageError, setImageError] = useState(false);
  
  const sizes = {
    small: { height: 32, fontSize: 20 },
    medium: { height: 40, fontSize: 28 },
    large: { height: 50, fontSize: 36 }
  };
  
  const s = sizes[size];
  
  // Correct R2 public URL
  const logoUrl = 'https://pub-ee11aac9be2045e4b33172e981203d17.r2.dev/logo.png';
  
  // Fallback if image fails
  if (imageError) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
      }}>
        <div style={{
          width: s.height + 'px',
          height: s.height + 'px',
          background: 'linear-gradient(135deg, #DC2626 0%, #991B1B 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: (s.height * 0.5) + 'px',
          boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)'
        }}>
          📧
        </div>
        <span style={{ 
          fontSize: s.fontSize + 'px',
          fontWeight: '800',
          color: '#FFFFFF',
          letterSpacing: '-0.02em'
        }}>
          Mail
        </span>
      </div>
    );
  }
  
  // Logo image + white "Mail" text
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '8px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
    }}>
      <img 
        src={logoUrl}
        alt="Addison"
        style={{
          height: s.height + 'px',
          width: 'auto',
          objectFit: 'contain'
        }}
        onError={() => setImageError(true)}
      />
      <span style={{ 
        fontSize: s.fontSize + 'px',
        fontWeight: '800',
        color: '#FFFFFF',
        letterSpacing: '-0.02em'
      }}>
        Mail
      </span>
    </div>
  );
};

export default Logo;

